export default __webpack_public_path__ + "static/media/test4.2d0b6a3d.png";